import HttpFactory from '../factory'
import type { User } from '../types/auth/user'

class UsersModule extends HttpFactory<any[]> {
  private PATH = '/users'

  getToast() {
    const { $toast: toast } = useNuxtApp()

    return toast
  }

  async get(id?: string): Promise<User | User[]> {
    if (!id) {
      let arr: any[] = []
      let nextPageUrl = '?pageSize=100'
      do {
        await this.call<any>('GET', `${this.PATH}${nextPageUrl}`).then((response) => {
          arr = arr.concat(response.items)
          nextPageUrl = response.nextPageUrl
        })
      } while (nextPageUrl)
      return arr
    } else return await this.call<any>('GET', `${this.PATH}/${id}`)
  }

  async getUserRole(id?: string): Promise<any> {
    return await this.call<any>('GET', `${this.PATH}/${id}/roles`)
  }

  async getUserRoleV2(id?: string): Promise<any> {
    return await this.call<any>('GET', `/roles?userId=${id}`)
  }

  async getPermissions(): Promise<any> {
    return await this.call<any>('GET', `${this.PATH}/permissions`)
  }

  async saveUserRole(obj: any, data: any): Promise<User | User[]> {
    return await this.call<any>('PATCH', `${this.PATH}/${obj.id}/roles`, data)
  }

  async saveUserRoleV2(obj: any, data: any): Promise<User | User[]> {
    return await this.call<any>('PUT', `/roles/?userId=${obj.id}`, data)
  }

  async extendPasswordExpiration(id: any, data: any): Promise<User | User[]> {
    return await this.call<any>('POST', `${this.PATH}/${id}/authentication-factors/action`, data)
  }

  async save(obj: any): Promise<User | void> {
    const data = {
      disabled: obj.disabled,
    }
    try {
      return await this.call<any>('PATCH', `${this.PATH}/${obj.id}?revision=${obj.revision}`, data)
    } catch (error: any) {
      this.getToast().warning(
        'Erreur lors de la mise à jour : ' +
          error.response?.data.errorCode +
          '\n\n' +
          'Raison(s) :\n' +
          error.response?.data.message,
        { timeout: 5000 },
      )
    }
  }
}

export default UsersModule
